import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/contact-form/contact-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/any-question.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/gradient.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/learnMore.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/light-gradient.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/play.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
